import { render, staticRenderFns } from "./choose-store.vue?vue&type=template&id=2ff4bf33"
import script from "./choose-store.vue?vue&type=script&lang=js"
export * from "./choose-store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports